import { gql } from '@apollo/client'

/* eslint-disable import/prefer-default-export */
export const DOCUMENT_SEMANTIC_SEARCH = gql`
  query DocumentSemanticSearchStitch(
    $input: DocumentSemanticSearchInput!
    $includeSummary: Boolean!
    $includeProducts: Boolean!
    $includeArticles: Boolean!
  ) {
    documentSemanticSearch(input: $input) {
      resultId
      language
      spans {
        contentId
        featureMediaId
        startTimecode
        endTimecode
        transcriptText
        matchedText
        content {
          title
          shortDescription
          path
          episodeNumber
          seasonNumber
          contentSeries {
            title
          }
          imageContentRelationships(
            types: ["d6-keyart-no-text"]
            language: ["en", "_primary"]
          ) {
            image {
              url
            }
          }
        }
      }
      stitchedPlayback {
        manifestUrl
        subtitlesUrl
        expiresAt
        unavailableReason
        stitchedWithPartialContent
        spans {
          contentId
          featureMediaId
          startTimecode
          endTimecode
          kind
          content {
            title
            path
            imageContentRelationships(
              types: ["d6-keyart-no-text"]
              language: ["en", "_primary"]
            ) {
              image {
                url
              }
            }
          }
        }
      }
      summary @include(if: $includeSummary)
      products @include(if: $includeProducts) {
        id
        title
        shortDescription(truncate: 160)
        path
        ctaPath
        ctaProductUrl
        imageContentRelationships(
          types: ["keyart-4x3-with-text", "d6-keyart-with-text"]
          language: ["en", "_primary"]
        ) {
          type
          image {
            url
          }
        }
      }
      articles @include(if: $includeArticles) {
        id
        title
        seoDescription
        path
      }
    }
  }
`
